import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  AccountState,
  LicenseCode,
  HttpAccountFilters,
} from '@account-users/account/models';

import { Group, LicenseV2 } from './models';
import {
  getFeatureToggleGroups,
  getFeatureToggleGroupsIsLoading,
  getFeatureToggleLicenses,
  getFeatureToggleLicensesIsLoading,
  FeatureToggleState,
} from './store';
import { Observable } from 'rxjs';
import { LicenseActions } from './store/licenses';
import { GroupActions } from './store/groups';

@Injectable()
export class FeatureToggleStateService {
  constructor(private readonly store: Store<FeatureToggleState>) {}

  public selectLicenses(): Observable<LicenseV2[]> {
    return this.store.pipe(select(getFeatureToggleLicenses)) as Observable<
      LicenseV2[]
    >;
  }

  public selectLicesesIsLoading(): Observable<boolean> {
    return this.store.pipe(
      select(getFeatureToggleLicensesIsLoading),
    ) as Observable<boolean>;
  }

  public selectGroups(): Observable<Group[]> {
    return this.store.pipe(select(getFeatureToggleGroups)) as Observable<
      Group[]
    >;
  }

  public selectGroupsIsLoading(): Observable<boolean> {
    return this.store.pipe(
      select(getFeatureToggleGroupsIsLoading),
    ) as Observable<boolean>;
  }

  public loadLicenses(accountId: string, filters?: HttpAccountFilters) {
    this.store.dispatch(
      LicenseActions.GetLicenses.request({ accountId, filters }),
    );
  }

  public loadGroups() {
    this.store.dispatch(GroupActions.GetGroups.request());
  }

  public addLicense(accountId: string, licenseCode: LicenseCode) {
    this.store.dispatch(
      LicenseActions.AddLicense.request({ accountId, licenseCode }),
    );
  }

  public updateLicense(
    accountId: string,
    licenses: { licenseCode: LicenseCode; state?: AccountState }[],
  ) {
    this.store.dispatch(
      LicenseActions.UpdateLicense.request({ accountId, licenses }),
    );
  }

  public removeLicense(accountId: string, licenseCode: LicenseCode) {
    this.store.dispatch(
      LicenseActions.RemoveLicense.request({ accountId, licenseCode }),
    );
  }
}
